import request from 'api/request';

export default function lastCompletedTicketsRoute() {
  return request({ url: '/tickets/last' });
}
